import type { AxiosResponse } from 'axios';
import type { ThunkAction } from 'redux-thunk';

import ApiClient, { createTokenConfig, isCancelled } from 'api/ApiClient';
import store from 'store';
import { NotificationsAction, showError } from '@spike/notifications-action';

import {
    ADDONS_INSIGHTS_REPORT_GET_ERROR,
    ADDONS_INSIGHTS_REPORT_GET_START,
    ADDONS_INSIGHTS_REPORT_GET_SUCCESS,
    AddonsInsightsReportAction
} from './AddonsInsightsReportActionsTypes';

import type { AddonsInsightsReportDto } from './AddonsInsightsReportDto';
import { convertToAddonsInsightsReport } from './addonsInsightsReportConverter';
import type { AddonsInsightsReport } from 'model/AddonsInsightsReport';

export const getAddonsInsightsReport = (
    start?: string,
    end?: string,
    page?: number,
    perPage?: number
): ThunkAction<void, null, null, AddonsInsightsReportAction | NotificationsAction> => {
    return async dispatch => {
        dispatch(getStart());

        const { marketplaceId, token } = store.getState().login.auth;

        let url = `/addons_insights_report?marketplace_id=${marketplaceId}`;
        if (start) url += `&start=${start}`;
        if (end) url += `&end=${end}`;
        if (page) url += `&page=${page}`;
        if (perPage) url += `&per_page=${perPage}`;

        try {
            const response: AxiosResponse<AddonsInsightsReportDto> = await ApiClient.get(
                url,
                createTokenConfig(token!)
            );
            dispatch(getSuccess(convertToAddonsInsightsReport(response.data)));
        } catch (apiError) {
            if (!isCancelled(apiError)) {
                dispatch(getError());
                dispatch(showError('Could not load Add-ons insights report.'));
            }
        }
    };
};

const getStart = (): AddonsInsightsReportAction => ({
    type: ADDONS_INSIGHTS_REPORT_GET_START
});

const getSuccess = (report: AddonsInsightsReport): AddonsInsightsReportAction => ({
    type: ADDONS_INSIGHTS_REPORT_GET_SUCCESS,
    payload: { report }
});

const getError = (): AddonsInsightsReportAction => ({
    type: ADDONS_INSIGHTS_REPORT_GET_ERROR
});
